var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsTableRestaurantOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32464 9H19.6746L18.8246 6H5.19964L4.32464 9ZM16.7996 11H7.22464L6.94964 13H17.0496L16.7996 11ZM3.99964 20L5.22464 11H2.99964C2.66631 11 2.40364 10.8667 2.21164 10.6C2.02031 10.3333 1.96631 10.0417 2.04964 9.725L3.47464 4.725C3.54131 4.50833 3.65798 4.33333 3.82464 4.2C3.99131 4.06667 4.19131 4 4.42464 4H19.5746C19.808 4 20.008 4.06667 20.1746 4.2C20.3413 4.33333 20.458 4.50833 20.5246 4.725L21.9496 9.725C22.033 10.0417 21.979 10.3333 21.7876 10.6C21.5956 10.8667 21.333 11 20.9996 11H18.7996L19.9996 20H17.9996L17.3246 15H6.67464L5.99964 20H3.99964Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsTableRestaurantOutline);
export default __webpack_public_path__ + "static/media/material-symbols_table-restaurant-outline.a3ddf15063a4fa7963608c1085adbd5a.svg";
export { ForwardRef as ReactComponent };